import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)


const routes = [
    {
        path: '',
        redirect: '/home'
    },
    {
        path:'/home',
        component:() => import('@/views/home.vue')
    },
    {
        path: '/about',
        component:() => import('@/views/about.vue')
    },
    {
        path: '/service',
        component:() => import('@/views/service.vue'),
        children:[
            {
                path: '/smartProject',
                component:() => import('@/views/components/serviceContent/smartProject/index.vue')
            },
            {
                path: '/propertyDev',
                component:() => import('@/views/components/serviceContent/propertyDev/index.vue')
            },
            {
                path: '/businessOperation',
                component:() => import('@/views/components/serviceContent/businessOperation/index.vue')
            },
            {
                path: '/investment',
                component:() => import('@/views/components/serviceContent/investment/index.vue')
            },
            {
                path: '/evChargingStation',
                component:() => import('@/views/components/serviceContent/evChargingStation/index.vue')
            },
            {
                path: '/greatHealth',
                component:() => import('@/views/components/serviceContent/greatHealth/index.vue')
            },
        ]
    },
    {
        path: '/cases',
        component:() => import('@/views/case.vue')
    },
    {
        path: '/companyNews',
        component:() => import('@/views/companyNews.vue')
    },
    {
        path: '/contact',
        component:() => import('@/views/contact.vue')
    },
    {
        path: '/detailPage',
        component:() => import('@/views/detailPage.vue')
    },
    {
        path: '/productDetailPage',
        component:() => import('@/views/productDetailPage.vue')
    }

]

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior(){
        return{x:0,y:0}
    }
})

export default router